import { LocaleService } from '@sm360/widget-commons-core-services';
import { LoaderAnim } from '@sm360/widget-commons-basic-components';

// eslint-disable-next-line import/no-named-as-default
import Tile from './components/Tile/Tile.jsx';

import en from './i18n/en.json';
import fr from './i18n/fr.json';

LocaleService.loadTranslations({ en, fr });

const version = process.env.VERSION;
const LoadingTile = LoaderAnim;

export { LoadingTile, Tile, version };

export default Tile;
